class Projects {
  constructor(el) {
    if (!el) return
    this.dom = {}
    this.dom.el = el
    this.setupDom()
    this.bindEvents()
  }

  setupDom = () => {
    this.dom.allTag = document.getElementById('allTag')
    this.dom.tags = Array.from(this.dom.el.querySelectorAll('.category-buttons input.tag'))
    this.dom.projects = Array.from(this.dom.el.querySelectorAll('.ref-project-list > li'))
  }

  bindEvents = () => {
    this.dom.tags.forEach(tag => tag.addEventListener('change', this.onFilter))
    this.dom.allTag.addEventListener('change', this.onFilterAll)
  }

  onFilterAll = e => {
    if (e.target.checked) {
      this.dom.tags.forEach(tag => tag.checked = false)
    }
    else { // Prevent deselect all
      e.target.checked = true
    }
    this.doFilter()
  }

  onFilter = e => {
    if (e.target.checked) {
      this.dom.allTag.checked = false
    }
    else if (this.dom.tags.filter(tag => tag.checked).length === 0) {
      this.dom.allTag.checked = true
    }
    this.doFilter()
  }

  doFilter = () => {
    if (this.dom.allTag.checked) {
      this.dom.projects.forEach(p => p.style.display = 'block')
    }
    else {
      var filter = this.dom.tags.filter(tag => tag.checked).map(tag => tag.dataset.category)
      this.dom.projects.forEach(p => {
        var categories = p.dataset.category.split(',')
        const union = categories.filter(value => filter.includes(value))
        p.style.display = union.length === 0 ? 'none' : 'block'
      })
    }
  }

  static init = () => {
    const projectPage = document.querySelector('.c-projects')
    new Projects(projectPage)
  }
}

export default Projects
